import React, { useState, useRef, useEffect } from 'react';
import MoreUpIcon from './icons/MoreUpIcon';
import DotDropdownMenu from './DotDropdownMenu';
import EditIco from './icons/EditIco';
import DeleteIco from './icons/TrashIco';
import SyncIco from './icons/SyncIco';
import ContentCopyIco from './icons/ContentCopyIco';

const ResizableDraggableCard = ({ id, x, y, width, height, type, containerWidth, containerHeight, onDrag, onResize, title, children, onDuplicate, onUpdate, onEdit = () => {},onDelete, headerColor, headerTextColor }) => {
  const [dragging, setDragging] = useState(false);
  const [resizing, setResizing] = useState(false);
  const [resizeFromBottom, setResizeFromBottom] = useState(false);
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });
  const [startSize, setStartSize] = useState({ width: 0, height: 0 });
  const [isHovered, setIsHovered] = useState(false);
  const [isModified, setIsModified] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  
  const cardRef = useRef(null);

  const options = [
    { name: "Duplicar", icon: ContentCopyIco, action: () => onDuplicate(id) },
    { name: "Editar", icon: EditIco, action: () => onEdit(id,type, title) },
    { name :"Guardar", icon: SyncIco, action: () => onUpdate(id,x,y,width,height) },
    { name: "Eliminar", icon: DeleteIco, action: () => onDelete(id) }
  ];


  const handleMouseDown = (e) => {
    if (e.target.classList.contains('resize-handle-bottom')) {
      setIsModified(true);
      setIsUpdating(true);
      setResizing(true);
      setResizeFromBottom(true);
      setStartSize({ width, height });
      setStartPos({ x: e.clientX, y: e.clientY });
    } else if (e.target.classList.contains('resize-handle-corner') || e.target.closest('.resize-handle-corner')) {
      setIsModified(true);
      setIsUpdating(true);
      setResizing(true);
      setResizeFromBottom(false);
      setStartSize({ width, height });
      setStartPos({ x: e.clientX, y: e.clientY });
    } else if (e.target.classList.contains('card-header')) {
      setIsModified(true);
      setIsUpdating(true);
      setDragging(true);
      setStartPos({ x: e.clientX - x, y: e.clientY - y });
    }
  };

  const handleMouseMove = (e) => {
    if (dragging) {
      const newX = e.clientX - startPos.x;
      const newY = e.clientY - startPos.y;
      onDrag(id, newX, newY);
      setIsModified(true);
      setIsUpdating(true);
    } else if (resizing) {
      setIsModified(true);
      setIsUpdating(true);
      if (resizeFromBottom) {
        const newHeight = Math.max(100, startSize.height + e.clientY - startPos.y);
        onResize(id, width, newHeight);
      } else {
        const newWidth = Math.max(100, startSize.width + e.clientX - startPos.x);
        const newHeight = Math.max(100, startSize.height + e.clientY - startPos.y);
        onResize(id, newWidth, newHeight);
      }
    }
  };

  const handleMouseUp = () => {
    setIsModified(false);
    if (dragging) {
      setDragging(false);
    }
    if (resizing) {
      setResizing(false);
      setResizeFromBottom(false);
    }
  };

  useEffect(() => {
    if (dragging || resizing) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [dragging, resizing]);

  useEffect( () => {
    console.log(isModified);
    if (!isModified && isUpdating) {
      onUpdate(id,x,y,width,height);
      setIsUpdating(false);
    }
  }, [isModified,isUpdating])

  return (
    <div
      ref={cardRef}
      className={`absolute overflow-clip bg-white border border-gray-300 shadow-md ${dragging || resizing ? 'select-none' : ''}`}
      style={{
        left: x,
        top: y,
        width,
        height,
        // La card que se está arrastrando/redimensionando sigue al cursor
        // 1:1 (sin transición); el resto anima suavemente hacia la
        // posición que le toca en la previsualización del nuevo layout.
        transition: (dragging || resizing)
          ? 'none'
          : 'left 150ms ease-out, top 150ms ease-out, width 150ms ease-out, height 150ms ease-out',
        // Sin esto, el orden de apilado lo decide el orden en el array de
        // cards (todas tienen z-index automático) - si arrastrás una card
        // por encima de otra que viene DESPUÉS en ese array, visualmente
        // pasa "por detrás" de ella mientras se superponen. Se eleva la
        // card activa por encima de todas mientras se arrastra/redimensiona.
        zIndex: (dragging || resizing) ? 50 : 1,
      }}
      onMouseDown={handleMouseDown}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="card-header  font-semibold text-gray-600 p-2 cursor-move flex justify-between"
        style={{
          backgroundColor: headerColor || undefined,
          color: headerTextColor || undefined,
        }}
      >
        {title}
        <DotDropdownMenu 
          options={options}
          dotColor={headerTextColor}
        /> 
      </div>
      <div className="h-full overflow-hidden">
        {children}
      </div>
      <div
        className="resize-handle-bottom absolute bottom-0 left-0 w-full h-4 cursor-s-resize"
      />
      <div
        className="resize-handle-corner absolute bottom-0 right-0 w-5 h-5 cursor-se-resize flex items-center justify-center transform rotate-[-270deg]"
        onMouseDown={handleMouseDown}
      >
        {isHovered && (
          <div className='pb-2 pl-2'>
            <MoreUpIcon width='15px' height='15px' fill='gray' />
          </div>
        )}
      </div>
    </div>
  );
};

export default ResizableDraggableCard;
